// Day stepping for the day-at-a-time clinical views.
//
// Both the medication grid and the task list are bounded to a single day: the
// task endpoint applies no date filter of its own, so an unbounded fetch
// returns every row ever scheduled for the admission — months of history and
// weeks of future in one scroll, which is what made those screens unreadable.

export function todayStr(d = new Date()) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

// Parsed as local midnight — "2026-08-04" alone would be read as UTC and can
// land on the previous day west of Greenwich.
export function shiftDay(dateStr, days) {
  const d = new Date(`${dateStr}T00:00:00`);
  d.setDate(d.getDate() + days);
  return todayStr(d);
}
